import React from 'react';

const Landing = () => {
  return null;
};

export default Landing;